import React from "react"
import { FaListUl } from "react-icons/fa"
import { FaListOl } from "react-icons/fa"
// import { FaList } from "react-icons/fa6"

import classes from "./EditorLists.module.scss"
import clsx from "clsx"

const EditorLists = (props) => {
  const { editor } = props

  return (
    <div className={classes["container"]}>
      <button
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={clsx(
          classes["button"],
          editor.isActive("bulletList") && classes["active"]
        )}
      >
        <FaListUl />
      </button>
      <button
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={clsx(
          classes["button"],
          editor.isActive("orderedList") && classes["active"]
        )}
      >
        <FaListOl />
      </button>
      {/* <button
        className={classes["button"]}
        onClick={() => editor.chain().focus().toggleTaskList().run()}
      >
        <FaList />
      </button> */}
    </div >
  )
}

export default EditorLists